<script>
    import {onMount} from "svelte";
    import {getStyleValue, imageUrl} from "../../Common/tools"
    import TextEditor from "../../Common/TextEditor.svelte";
    import Button from "./Button.svelte";
    import {initResizable} from "../global";
    import {External} from "../../external";

    export let data, meta, globalStyle, onChange, onFocus;
    let top, bottom;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {content: val});
    }

    onMount(function () {
      let jqTop = External.$(top);
      let jqBottom = External.$(bottom);

      let resizeTop = function (event, ui) {
          if (ui.size.height < 0) {
              ui.size.height = 0;
          }
          data.style = Object.assign({}, data.style, {paddingTop: ui.size.height + "px"});
      };

      let resizeBottom = function (event, ui) {
          if (ui.size.height < 0) {
              ui.size.height = 0;
          }
          data.style = Object.assign({}, data.style, {paddingBottom: ui.size.height + "px"});
      };

      initResizable(jqTop, resizeTop, jqBottom, resizeBottom, () => onChange('padding'), onFocus);
    });
</script>
<tr>
    <th class="column mobile-12"
        style="background-repeat: no-repeat; background-position: center; background-size: cover;" width="{getStyleValue(globalStyle.width, 600)}"
        bgcolor="" background={imageUrl(data, External.resources + '/images/marketing/placeholders/700x500.png')}>
        <table>
            <tbody>
                <tr>
                    <th class="column mobile-12"
                        width="{getStyleValue(globalStyle.width, 600)*0.2}">
                    </th>
                    <th class="column mobile-12"
                        style="background-repeat: no-repeat; background-position: center; background-size: cover;" width="{getStyleValue(globalStyle.width, 600)*0.6}"
                        bgcolor="">
                        <div class="spacer" style="line-height: {data.style.paddingTop};height: {data.style.paddingTop};">
                            <div class="spacer-top" bind:this={top} style="left:0;top:0;position:absolute;width:100%;height:{data.style.paddingTop}">
                                &nbsp;
                            </div>
                        </div>
                        <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
                        <div class="spacer" style="font-size: 35px; line-height: 35px;">&nbsp;</div>
                        <center>
                            <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
                        </center>
                        <div class="spacer" style="line-height: {data.style.paddingBottom}; height: {data.style.paddingBottom};">
                            <div class="spacer-bottom" bind:this={bottom} style="left:0;bottom:0;position:absolute;width:100%;height:{data.style.paddingBottom}">
                                &nbsp;
                            </div>
                        </div>
                    </th>
                    <th class="column mobile-12"
                        width="{getStyleValue(globalStyle.width, 600)*0.2}">
                    </th>
                </tr>
            </tbody>
        </table>
    </th>
</tr>
